var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { clearable: "", placeholder: "比赛轮次" },
                  model: {
                    value: _vm.paramsData.round_name,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "round_name", $$v)
                    },
                    expression: "paramsData.round_name"
                  }
                },
                _vm._l(_vm.roundsList, function(item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "home_team_name", label: "主队", align: "center" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "home_score",
              label: "主队得分",
              align: "center",
              width: "100px"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "away_team_name", label: "客队", align: "center" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "away_score",
              label: "客队得分",
              align: "center",
              width: "100px"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "location", label: "比赛场地", align: "center" }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0 ? _c("span", [_vm._v("未开始")]) : _vm._e(),
                    row.status == 1 ? _c("span", [_vm._v("进行中")]) : _vm._e(),
                    row.status == 2 ? _c("span", [_vm._v("已结束")]) : _vm._e(),
                    row.status == 3 ? _c("span", [_vm._v("已取消")]) : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "winnerName", label: "胜利队" }
          }),
          _c("el-table-column", {
            attrs: { prop: "match_duration", label: "比赛时长(分钟)" }
          }),
          _c("el-table-column", {
            attrs: { prop: "round_name", label: "比赛轮次" }
          }),
          _c("el-table-column", {
            attrs: { prop: "match_phase", label: "比赛阶段" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.match_phase == "regular"
                      ? _c("span", [_vm._v("常规赛")])
                      : row.match_phase == "extra_time"
                      ? _c("span", [_vm._v("加时赛")])
                      : row.match_phase == "penalty"
                      ? _c("span", [_vm._v("已完成")])
                      : row.match_phase == "finished"
                      ? _c("span", [_vm._v("已完成")])
                      : _c("span", [_vm._v("/")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "match_time", label: "比赛时间" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "120",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "x-c" },
                      [
                        scope.row.status == 0
                          ? _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.updateCoach.init(scope.row)
                                  }
                                }
                              },
                              [_vm._v(" 修改 ")]
                            )
                          : _vm._e(),
                        scope.row.away_team_id && scope.row.home_team_id
                          ? [
                              scope.row.status == 1 || scope.row.status == 2
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "controlsBtn",
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.updateScore.init(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" 录入比分 ")]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("updateCoach", {
        ref: "updateCoach",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("updateScore", {
        ref: "updateScore",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }